import { useCallback, useEffect, useState } from 'react';
import axiosInstance from '../axios';

/**
 * Fetches and exposes the location hierarchy tree used by cascade filters.
 *
 * @returns {{
 * 	hierarchy: Record<string, any>,
 * 	isLoading: boolean,
 * 	error: any,
 * 	refreshHierarchy: () => Promise<void>
 * }}
 */
export default function useHierarchy() {
	const [hierarchy, setHierarchy] = useState({});
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(null);

	// Fetch hierarchy data from the API
	const fetchHierarchy = useCallback(async () => {
		setIsLoading(true);
		setError(null);

		try {
			const response = await axiosInstance.get('/hierarchy/');
			setHierarchy(response.data || {});
		} catch (requestError) {
			setHierarchy({});
			setError(requestError);
		} finally {
			setIsLoading(false);
		}
	}, []);

	// Fetch hierarchy on component mount
	useEffect(() => {
		fetchHierarchy();
	}, [fetchHierarchy]);

	return {
		hierarchy,
		isLoading,
		error,
		refreshHierarchy: fetchHierarchy,
	};
}
